import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

interface StatusPageProps {
  statusCode: number | string;
  title: string;
  description: string;
  seoTitle: string;
  seoDescription: string;
  noIndex?: boolean;
  actionLabel?: string;
  actionHref?: string;
}

const StatusPage = ({
  statusCode,
  title,
  description,
  seoTitle,
  seoDescription,
  noIndex = true,
  actionLabel = "Terug naar Home",
  actionHref = "/",
}: StatusPageProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead title={seoTitle} description={seoDescription} noIndex={noIndex} />
      <Header />

      <main className="flex-1 flex items-center justify-center bg-gradient-to-br from-primary/10 via-secondary/20 to-background">
        <div className="container text-center py-20">
          <div className="text-8xl mb-6">🦙</div>
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-primary/80 mb-3">Er is iets misgegaan</p>
          <h1 className="text-4xl md:text-6xl font-bold mb-4">{statusCode}</h1>
          <h2 className="text-2xl md:text-3xl font-semibold mb-4">{title}</h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">{description}</p>
          <Button
            size="lg"
            className="bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70"
            asChild
          >
            <a href={actionHref}>
              <Home className="mr-2 h-5 w-5" aria-hidden="true" />
              {actionLabel}
            </a>
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default StatusPage;
